const initialState = {
    haveTrackedSomething: false,
    havePerformedFirstScroll: false
};

export default (state = initialState, action) => {
    switch(action.type){
        case "articles/PR_TRACKING_INIT":
        case "articles/PR_TRACKING_URL_SUCCESS":
        case "articles/PR_TRACKING_URL_ERROR":
            return {
                ...state,
                haveTrackedSomething: true
            };
        case "articles/PR_FIRST_SCROLL":
            return {
                ...state,
                havePerformedFirstScroll: true
            };
        default:
            return state;
    }
};
